export { default, Icon } from '../components/icon';
export { IconFacade } from '../components/icon-facade';